import * as Cookies from 'js-cookie';
import { HTTP } from './axios';
import Vue from 'vue';

const _baseUrl = process.env.VUE_APP_API_URL + '/api/v1';
const _send = async (
  method = 'GET',
  url,
  params = null,
  data = null,
  isNotify = true
  // headers
) => {
  try {

    let headers;
    if (Cookies.get('x-access-token')) {
      headers = {
        Authorization: 'Bearer ' + Cookies.get('x-access-token')
      };
    }else{
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('x-access-token')
      }
    }
    const response = await HTTP({
      headers,
      method,
      url: _baseUrl + url,
      params,
      data
    });

    if (method.toLocaleLowerCase() !== 'get' && isNotify) {
      if (response.data.message) {
        Vue.notify({
          group: 'toast',
          type: 'success',
          text: response.data.message
        });
      }
    }
    return {
      code: response.status === 201 ? 200 : response.status,
      ...response.data.data
    }
  } catch (error) {

    const data = error.response
    if (data && data.status) {
      if (data.status === 401) {
        Cookies.remove('x-access-token')
        Cookies.remove('vuex')
        Vue.notify({
          group: 'toast',
          type: 'warning',
          text: data.data.meta.message
        })
        window.location.href = '/'
      } else if (data.status === 400) {
        Vue.notify({
            group: 'toast',
            type: 'warning',
            text: data.data.meta.message,
          })
      } else if (data.status === 500) {
        // console.log('422', data.status)
        Vue.notify({
          group: 'toast',
          type: 'warning',
          text: data.data.meta.message
        })
      } else if (isNotify) {
        if (process.env.NODE_ENV !== 'production') {
          Vue.notify({
            group: 'toast',
            type: 'warning',
            text: data.data.message
          })
        }
      }
    } else if (isNotify) {
      if (process.env.NODE_ENV !== 'production') {
        Vue.notify({
          group: 'toast',
          type: 'error',
          text: 'Oops, something wrong'
        })
      }
    }
    return {
      code: data.status,
      ...data.data
    }
  }
}

// List api
const api = {
    fetchData: async (url, params, isNotify) => {
      return await _send('GET', url, params, null, isNotify);
    },
    postData: async (url, data, isNotify) => {
      return await _send('POST', url, null, data, isNotify);
    },
    putData: async (url, data, isNotify) => {
      return await _send('PUT', url, null, data, isNotify);
    },
    patchData: async (url, data) => {
      return await _send('PATCH', url, null, data);
    },
    deleteData: async (url, data) => {
      return await _send('DELETE', url, null, data);
    }
  }

export {
    api
};

